import { Autocomplete, FormControl, FormLabel, TextField } from '@mui/material';

import { useDAL } from '@/contexts/useDAL';

import { EmptySelect } from './emptySelect';

const title = 'RDS subnet group';

export const RDSSubnetGroupSelect = ({
  accountId,
  regionName,
  rdsSubnetGroupName,
  onChange,
}: {
  accountId?: string;
  regionName?: string;
  rdsSubnetGroupName?: string;
  onChange: (rdsSubnetGroupName: string, vpc: string) => void;
}) => {
  if (!accountId || !regionName) {
    return <EmptySelect title={title} />;
  }

  return (
    <InnerRDSSubnetGroupSelect
      accountId={accountId}
      regionName={regionName}
      rdsSubnetGroupName={rdsSubnetGroupName}
      onChange={onChange}
    />
  );
};

const InnerRDSSubnetGroupSelect = ({
  accountId,
  regionName,
  rdsSubnetGroupName,
  onChange,
}: {
  accountId: string;
  regionName: string;
  rdsSubnetGroupName?: string;
  onChange: (rdsSubnetGroupName: string, vpc: string) => void;
}) => {
  const dal = useDAL();
  const { data: body } = dal.restore.rdsSubnetGroup.useList(
    accountId,
    regionName
  );

  if (!body?.rdsSubnetGroups.length) {
    return <EmptySelect title={title} />;
  }

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <Autocomplete
        data-testid='rdsSubnetGroupSelect'
        clearOnBlur
        size='small'
        value={
          body.rdsSubnetGroups.find((x) => x.name === rdsSubnetGroupName) ||
          null
        }
        onChange={(event, newValue) =>
          onChange(newValue?.name || '', newValue?.vpc || '')
        }
        getOptionLabel={(option) => `${option.name} (${option.vpc})`}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder='Select'
              label=''
              InputLabelProps={{ shrink: true }}
            />
          );
        }}
        options={body.rdsSubnetGroups}
      />
    </FormControl>
  );
};
